import {ProductInterface} from "../../interfaces/catalog/ProductInterface";
import Product from "./Product";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import {useState} from "react";
import {sortProductsByStock} from "../../utils/productSort";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function ProductSlider({products, header}: {
    products: ProductInterface[],
    header: string
}) {

    const sortedProducts = sortProductsByStock(products);
    // кнопки и точки — в state: «вперёд» и точки стоят после ленты, и useRef на момент инициализации Swiper был ещё пуст
    const [prevEl, setPrevEl] = useState<HTMLButtonElement | null>(null);
    const [nextEl, setNextEl] = useState<HTMLButtonElement | null>(null);
    const [paginationEl, setPaginationEl] = useState<HTMLDivElement | null>(null);

    return (<div className="prod-cat">
        <div className="container">
            <div className="d-flex flex-column prod-cat__row">
                <div>
                    <div className="prod-cat__title t-two">{header}</div>
                    {/* стрелки и точки — вне ленты, чтобы не налезали на карточки */}
                    <div className="prod-cat__slider">
                        <button ref={setPrevEl} type="button" className="swiper-button-prev prod-cat__nav prod-cat__nav--prev" aria-label="Назад"/>
                        {prevEl && nextEl && paginationEl && <Swiper
                            modules={[Navigation, Pagination, Autoplay]}
                            spaceBetween={3}
                            slidesPerView={2}
                            slidesPerGroup={2}
                            navigation={{prevEl, nextEl}}
                            pagination={{el: paginationEl, clickable: true}}
                            autoplay={{ delay: 5000, disableOnInteraction: false }}
                            breakpoints={{
                                768: {
                                    slidesPerView: 3,
                                    slidesPerGroup: 3,
                                    spaceBetween: 3,
                                },
                                992: {
                                    slidesPerView: 4,
                                    slidesPerGroup: 4,
                                    spaceBetween: 3,
                                },
                                1400: {
                                    slidesPerView: 5,
                                    slidesPerGroup: 5,
                                    spaceBetween: 3,
                                },
                            }}
                        >
                            {sortedProducts.map((product, index) => (
                                <SwiperSlide key={`${product.id}-${product.link_type_id ?? 0}-${index}`}>
                                    <div className="prod-card"><Product product={product} /></div>
                                </SwiperSlide>
                            ))}
                        </Swiper>}
                        <button ref={setNextEl} type="button" className="swiper-button-next prod-cat__nav prod-cat__nav--next" aria-label="Вперёд"/>
                    </div>
                    <div ref={setPaginationEl} className="prod-cat__pagination"/>
                </div>
            </div>
        </div>
    </div>)
}
